// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.annotation-section-divider {
  text-align: center;
  position: relative;
  font-size: 14px;
  color: #475b70;
  margin: 10px 0px;
  width: calc(100% - 60px);
  left: 45px;
}

.annotation-section-divider-label {
  position: relative;
  z-index: 2;
  background-color: white;
  padding: 0 10px;
}

.annotation-section-divider-line {
  display: block;
  width: 100%;
  position: absolute;
  border-bottom: 1px solid #b1bdc9;
  top: 12px;
  height: 1px;
  z-index: 1
}`, "",{"version":3,"sources":["webpack://./src/Components/AnnotationDivider/AnnotationDivider.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;EACT,WAAW;EACX;AACF","sourcesContent":[".annotation-section-divider {\n  text-align: center;\n  position: relative;\n  font-size: 14px;\n  color: #475b70;\n  margin: 10px 0px;\n  width: calc(100% - 60px);\n  left: 45px;\n}\n\n.annotation-section-divider-label {\n  position: relative;\n  z-index: 2;\n  background-color: white;\n  padding: 0 10px;\n}\n\n.annotation-section-divider-line {\n  display: block;\n  width: 100%;\n  position: absolute;\n  border-bottom: 1px solid #b1bdc9;\n  top: 12px;\n  height: 1px;\n  z-index: 1\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
